export default __webpack_public_path__ + "static/media/search-icon.a002e829.svg";